import { legacy_createStore as createStore, combineReducers } from 'redux'
import { configureStore } from '@reduxjs/toolkit';
import cities from '../src/redux/cities/citiesSlice';

const initialState = {
  sidebarShow: true,
  theme: 'light',
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}


const store = configureStore({
  reducer: {
    //dashboard: dashboardReducer,
    cities: cities,
   
  },
  changeState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),//add reducers here
})

export default store